import {internalApi} from "../../common/axios";
import {buildUrl} from "../../shared/utils/net";
import {useQueryBase} from "../../shared/hooks/useHookBase";
import dayjs from "dayjs";

const fetchWidgetStatistics = async (type) => {
    const { data } = await internalApi.get(buildUrl('manager/analysis/widget', {type}));
    return data.rows;
}

export const useWidgetStatistics = (type) => {
    return useQueryBase([`${type}_widget`, type], () => fetchWidgetStatistics(type));
};

const fetchChartStatistics = async (type, dateRange = {begin: dayjs().subtract(1, 'day').startOf('day').unix(), end: dayjs().endOf('day').unix()}) => {
    const { data } = await internalApi.get(buildUrl('manager/analysis/chart', {
        type,
        begin: dateRange.begin,
        end: dateRange.end
    }));
    return data.rows;
}

export const useChartStatistics = (type, dateRange) => {
    return useQueryBase([`${type}_chart`, type, dateRange], () => fetchChartStatistics(type, dateRange));
};

const fetchRankingData = async (type, begin, end) => {
    const { data } = await internalApi.get(buildUrl('manager/analysis/ranking', {
        type,
        begin,
        end
    }));

    if (type === 'byCountry') {
        const total = data.rows.reduce((sum, row) => sum + row.total_price, 0);
        data.rows = data.rows.map(row => ({
            ...row,
            sales_ratio: total === 0 ? 0 : (row.total_price / total) * 100
        }));
    }

    return data.rows;
}

export const useRankingData = (type, begin, end) => {
    return useQueryBase([`${type}_ranking`, type, begin, end], () => fetchRankingData(type, begin, end));
};

export const downloadAllUserData = async () => {
    return await internalApi.get(buildUrl('manager/analysis/ranking', { type: 'all_users', begin: 0, end: 0 }));
}

const fetchRetentionData = async (yearMonth, country) => {
    const start = dayjs(yearMonth).startOf('month').format('YYYY-MM-DD');
    const end = dayjs(yearMonth).endOf('month').format('YYYY-MM-DD');

    const {data} = await internalApi.get(buildUrl('manager/analysis/retention', {country, start, end}));
    const sortedKeys = Object.keys(data.rows).sort((a, b) => new Date(b) - new Date(a));
    return sortedKeys.reduce((acc, key) => {
        acc[key] = data.rows[key];
        return acc;
    }, {});
}

export const useRetentionData = (yearMonth, country) => {
    return useQueryBase(['retention_data', yearMonth, country], () => fetchRetentionData(yearMonth, country));
};

